<template>
  <v-text-field
    v-bind="$attrs"
    :label="label"
    :rules="[IsNum, ...rules]"
    :value="myValue"
    @input="InputEventQty"
  ></v-text-field>
</template>
<script>
export default {
  props: {
    label: [String],
    rules: {
      type: Array,
      default: () => [],
    },
    value: [Number],
  },

  computed: {
    myValue() {
      if (isNaN(this.value)) return 0;
      if (typeof this.value === "number") return this.value.toLocaleString();
      return 0;
    },
  },

  methods: {
    // IsNum(v) {
    //   return !isNaN(v.replace(/,/g, "")) || "it is not number";
    // },
    IsNum(v) {
      if (v === undefined || v === null || v.toString().trim() === "")
        return `${this.label} is required`;
      const number = v.toString().replace(/,/g, "");
      if (!isNaN(number))
        return parseFloat(number) >= 0 || "Negative is not allowed";
      return "it is not number";
    },

    InputEventQty(v) {
      // this.$nextTick(() => {
      // console.log(v, "outside");
      // if (v === NaN) this.$emit("input", 0);
      if (!v || isNaN(v.toString().replace(/,/g, ""))) {
        this.$emit("input", 0);
        // console.log(v);
        return "";
      }
      // } else if (!v || isNaN(v.toString().replace(/,/g, ""))) return;
      //   this.ItemRow.qty = Number(v.replace(/,/g, ""));
      if (v && !isNaN(v.toString().replace(/,/g, "")))
        this.$emit(
          "input",
          Number(
            v
              .toString()
              .replace(/,/g, "")
              .trim()
          )
        );
    },
  },
};
</script>
